export const adminAppVersion = "0.0.1"
export const clientAppVersion = "0.0.2"
